export default __webpack_public_path__ + "static/media/get-super-img.f52b5fc2.png";